import api from '../../../config/axios'

export interface UnifiedSearchResult {
  type: 'sensor' | 'calibration' | 'result'
  id: string
  serial_number?: string
  is_active?: boolean
  condition?: string
  calibration_type?: string
  created_by?: string
  status?: string
  comments?: string | null
  rank: number
}

export interface UnifiedSearchParams {
  q: string
  limit?: number
}

export const SearchService = {
  unifiedSearch: (params: UnifiedSearchParams) =>
    api.get<UnifiedSearchResult[]>('search/api/search', {
      params: {
        q: params.q,
        limit: params.limit || 20,
      },
    }).then(res => res.data),
}

